import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, EditIcon, TrashIcon, DownloadExcelIcon, GoogleMapsIcon, BankIcon, DocumentIcon, ViewIcon, LockIcon, DisableIcon, CheckWhiteIcon } from 'assets/icons';
import { UserService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import ModalValidation from './modal-validation';
import ModalLocation from './modal-location';
import ModalBank from './modal-bank';
import ModalCredolab from './modal-credolab';
import ModalPassword from './modal-password';
import ModalPoints from './modal-points';
import { VzlaFlagImage, ColFlagImage } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INCLUDE_DELETED_USERS = {
	YES: 1,
	NO: 0
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	since_bravealo: '',
	until_bravealo: '',
	credolab_id: '',
	since_score: '',
	until_score: '',
	country_id: '',
	status: ''
}

declare var window: any;

class Users extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha',
			'Nombre',
			'Nº documento',
			'Teléfono',
			'Score',
			'Correo',
			'CredoLab',
			'Ubicación',
			'Puntos',
			'Identidad',
			'País',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		visible_points: false,
		item: null,
		visible_location: false,
		visible_validation: false,
		visible_bank: false,
		visible_credolab: false,
		credolab_accepted: 0,
		visible_password: false,
		total_rows: 0,
		include_deleted_users: INCLUDE_DELETED_USERS.NO,
		loading_count: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Validación de Usuarios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		this.loadUsers(withoutLoading,callback);
		this.loadCount();
	}

	loadCount = async () => {
		await this.setState({
			loading_count: true
		});
		const res: any = await UserService.admin.getCount({
			withoutLoading: true,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			since_bravealo: this.state.form.since_bravealo && moment(this.state.form.since_bravealo).format('YYYY-MM-DD'),
			until_bravealo: this.state.form.until_bravealo && moment(this.state.form.until_bravealo).format('YYYY-MM-DD'),
			include_deleted_users: this.state.include_deleted_users
		});
		this.setState({
			loading_count: false,
			total_rows: res.total_rows || 0
		});
	}

	loadUsers = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			since_bravealo: this.state.form.since_bravealo && moment(this.state.form.since_bravealo).format('YYYY-MM-DD'),
			until_bravealo: this.state.form.until_bravealo && moment(this.state.form.until_bravealo).format('YYYY-MM-DD'),
			include_deleted_users: this.state.include_deleted_users
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count,
			credolab_accepted: res.credolab_accepted
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	changePassword = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_password: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el usuario?',async () => {
			await UserService.admin.delete({
				user_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el usuario correctamente");
			this.load(true);
		});
	}

	changeUserStatus = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm(`¿Desea ${ item.status == Constants.USER_STATUS.ACTIVE ? 'desactivar' : 'activar' } el usuario?`,async () => {
			await UserService.admin.changeUserStatus({
				user_id: item?.id
			});	
			Globals.showSuccess(`Se ha ${ item.status == Constants.USER_STATUS.ACTIVE ? 'desactivado' : 'activado' } el usuario correctamente`);
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	onClosePassword = () => {
		this.setState({
			visible_password: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	getColor = (item: any) => {
		let color = Colors.green;

		if (item.verified == Constants.VERIFIED_STATUS.PENDING) {
			color = Colors.orange;
		}
		else if (item.verified == Constants.VERIFIED_STATUS.REJECTED) {
			color = Colors.danger;
		}

		return color;
	}

	download = async () => {
		const res: any = await UserService.admin.downloadExcel({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			since_bravealo: this.state.form.since_bravealo && moment(this.state.form.since_bravealo).format('YYYY-MM-DD'),
			until_bravealo: this.state.form.until_bravealo && moment(this.state.form.until_bravealo).format('YYYY-MM-DD'),
			include_deleted_users: this.state.include_deleted_users
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	openValidation = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_validation: true,
			item
		});
	}

	closeValidation = () => {
		this.setState({
			visible_validation: false
		},() => {
			this.load(true);
		});
	}

	openLocation = (item: any) => {
		this.setState({
			visible_location: true,
			item
		});
	}

	closeLocation = () => {
		this.setState({
			visible_location: false
		});
	}

	viewBank = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_bank: true,
			item
		});
	}

	onCloseBank = () => {
		this.setState({
			item: null,
			visible_bank: false
		},() => this.load(true));
	}

	onCloseCredolab = () => {
		this.setState({
			visible_credolab: false
		});
	}

	openCredolab = () => {
		this.setState({
			visible_credolab: true
		});
	}

	editPoints = (item: any) => {
		this.setState({
			visible_points: true,
			item
		});
	}
	
	onClosePoints = () => {
		this.setState({
			visible_points: false,
			item: null
		},() => this.load(true));
	}

	render() {
		const { visible, visible_location, visible_validation, visible_bank, visible_credolab, credolab_accepted, visible_password, visible_points, total_rows, loading_count } = this.state;

		return (
			<div id="admin-users">
				<Modal
		          className="modal-create-user"
		          visible={ visible }
		          title="Editar usuario"
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-users-points"
		          visible={ visible_points }
		          title="Editar beneficios"
		          onClose={ () => this.onClosePoints() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalPoints
		          	item={ this.state.item }
		            onClose={ () => this.onClosePoints() } />
		      	</Modal>

		      	<Modal
		          className="modal-create-user"
		          visible={ visible_password }
		          title="Cambiar contraseña"
		          onClose={ () => this.onClosePassword() }
		        >
		          <ModalPassword
		          	item={ this.state.item }
		            onClose={ () => this.onClosePassword() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-bank"
		          visible={ visible_bank }
		          title="Ver Datos Bancarios"
		          onClose={ () => this.onCloseBank() }
		        >
		          <ModalBank
		          	item={ this.state.item }
		            onClose={ () => this.onCloseBank() } />
		      	</Modal>

		      	<Modal
		          className="modal-credolab"
		          visible={ visible_credolab }
		          title="Configuración de Credolab"
		          onClose={ () => this.onCloseCredolab() }
		        >
		          <ModalCredolab
		            onClose={ () => this.onCloseCredolab() } />
		      	</Modal>

		      	<Modal
		          className="modal-users-google-maps"
		          visible={ visible_location }
		          title="Ubicación"
		          onClose={ () => this.closeLocation() }
		        >
		          <ModalLocation
		          	item={ this.state.item }
		            onClose={ () => this.closeLocation() } />
		      	</Modal>

		      	<Modal
		          className="modal-users-valid"
		          visible={ visible_validation }
		          title="Documentos"
		          onClose={ () => this.closeValidation() }
		        >
		          <ModalValidation
		          	item={ this.state.item }
		          	reload={ async () => {
		          		let item: any = this.state.item;
		          		item.verified = Constants.VERIFIED_STATUS.REJECTED;
		          		await this.setState({
		          			item
		          		});
		          		this.load(true);
		          	} }
		            onClose={ () => this.closeValidation() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Nombre o correo"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								<Input
									value={ this.state.form.credolab_id }
									name="credolab_id"
									placeholder="Buscar por código"
									label="Cód. CredoLab"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Seleccionar"
									label="País"
									name="country_id"
									color="white"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.country_id }
									options={ [
										{ value: Constants.COUNTRIES.VZLA.toString() , label: 'Venezuela' },
										{ value: Constants.COUNTRIES.COL.toString() , label: 'Colombia' }
									] } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Seleccionar"
									label="Estado"
									name="status"
									color="white"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.VERIFIED_STATUS.VERIFIED.toString(), label: 'Validados' },
										{ value: Constants.VERIFIED_STATUS.PENDING.toString(), label: 'Pendientes' },
										{ value: Constants.VERIFIED_STATUS.REJECTED.toString(), label: 'Rechazados' }
									] } />
							</div>
							<div className="row col-md">
								<div className="col-md-12">
									<p className="label">Fecha de Registro</p>
								</div>
								<div className="col-md-6">
									<DatePicker
										showYearDropdown={ true }
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-6">
									<DatePicker
										showYearDropdown={ true }
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="row col-md">
								<div className="col-md-12">
									<p className="label">Fecha de Bravealo</p>
								</div>
								<div className="col-md-6">
									<DatePicker
										showYearDropdown={ true }
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since_bravealo'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since_bravealo }
									/>
								</div>
								<div className="col-md-6">
									<DatePicker
										showYearDropdown={ true }
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until_bravealo'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until_bravealo }
									/>
								</div>
							</div>
							<div className="row col-md">
								<div className="col-md-12">
									<p className="label" style={{ marginBottom: '5px' }}>Rango Score</p>
								</div>
								<div className="col-md-6">
									<Input
										type="number"
										value={ this.state.form.since_score }
										name="since_score"
										placeholder="Desde"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-6">
									<Input
										type="number"
										value={ this.state.form.until_score }
										name="until_score"
										placeholder="Hasta"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-6">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" style={{ marginTop: '0px', marginRight: '15px', marginBottom: '10px' }} onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}

						{
							checkPermission(Constants.MODULES.USERS,'write') && (
								<button className="btn btn-credolab" onClick={ () => this.openCredolab() }>
									Configuración de Credolab
								</button>
							)
						}
					</div>
					<div className="col-md-6">
						<p className="total-rows"><span>Total Registros: </span> 
							{
								loading_count ? (
									<>
										<i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
									</>
								) : (
									<>{ total_rows }</>
								)
							}
						</p>
					</div>
				</div>

				<div className="check-container" onClick={ () => {
					this.setState({
						include_deleted_users: !this.state.include_deleted_users
					},() => {
						this.load(true);
					});
				} }>
					<div className={ `check ${ this.state.include_deleted_users == INCLUDE_DELETED_USERS.YES ? 'active' : '' }` }>
						{
							this.state.include_deleted_users == INCLUDE_DELETED_USERS.YES && (
								<img src={ CheckWhiteIcon } />
							)
						}
					</div>
					<p>Incluir usuarios eliminados</p>
				</div>

				<Table title="Usuarios Registrados" data={ this.state.data.length } header={ this.state.header } titleRight={
					<React.Fragment>
						{
							this.state.data.length > 0 && (
								<div className="container-add-table">
									<p>Descargar Excel</p>
									<button className="btn add-btn-table" onClick={ this.download }>
										<img src={ DownloadExcelIcon } />
									</button>
								</div>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index } style={ i.deleted_at ? { backgroundColor: '#FFEBEE' } : {} }>
								<td className="container-dates">
									<p className="bold">TuTurno</p>
									<p>{ i.created_at ? moment(i.created_at).format('DD/MM/YYYY') : '-' }</p>
									<p className="bold">Bravealo</p>
									<p>{ i.bravealo_created_at ? moment(i.bravealo_created_at).format('DD/MM/YYYY') : '-' }</p>
								</td>
								<td>{ i.name + ' ' + i.lastname }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ ((i.document_type?.name || '') + ((i.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || i.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + i.document }</td>
								<td>
								    {
								        i.phone && (
								            <p>
								                {i?.country_id === Constants.COUNTRIES.VZLA ? (i.phonecode?.name || '') : ''}
								                {i.phone}
								            </p>
								        )
								    }
								    {
								        i.person?.alternative_phone && (
								            <p>
								                {i?.country_id === Constants.COUNTRIES.VZLA ? (i.person?.alternative_phonecode?.name || '') : ''}
								                {i.person?.alternative_phone}
								            </p>
								        )
								    }
								</td>
								<td className={ i.credolab_score ? (credolab_accepted <= i.credolab_score ? 'credolab-active' : 'credolab-rejected') : '' }>{ i.credolab_score || '-' }</td>
								<td>{ i.email }</td>
								<td>{ i.credolab_id || '-' }</td>
								<td>
									<button className="btn btn-google-maps" onClick={ () => this.openLocation(i) }>
										<img src={ GoogleMapsIcon } className="google-maps-icon" />
									</button>
								</td>
								<td>
									<button className="btn btn-points" onClick={ () => {
										if (i.deleted_at == null)
											this.editPoints(i);
									} } disabled={ i.deleted_at != null || !checkPermission(Constants.MODULES.USERS,'write') }>
										{ i.points_history[0]?.final_amount || 0 }
									</button>
								</td>
								<td className="status" style={{
									color: this.getColor(i)
								}}>{ i.status_verified }</td>
								<td>
									{
										i.country_id == Constants.COUNTRIES.VZLA && (
											<Tooltip title="Venezuela">
												<img src={ VzlaFlagImage } className="flag" />
											</Tooltip>
										)
									}
									{
										i.country_id == Constants.COUNTRIES.COL && (
											<Tooltip title="Colombia">
												<img src={ ColFlagImage } className="flag" />
											</Tooltip>
										)
									}
								</td>
								<td className="container-icons">
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.openValidation(e,i) }>
											<img src={ DocumentIcon } />
										</a>
									</Tooltip>
									{
										i.deleted_at == null && (
										 	<Tooltip title="Datos Bancarios">
												<a className="link-icon" href="#" onClick={ (e: any) => this.viewBank(e,i) }>
													<img src={ BankIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.USERS,'write')  && i.deleted_at == null && (
											<Tooltip title={ i.status == Constants.USER_STATUS.ACTIVE ? 'Desactivar' : 'Activar' }>
												<a className={ `link-icon link-icon-status ${ i.status == Constants.USER_STATUS.ACTIVE ? 'active' : '' }` } href="#" onClick={ (e: any) => this.changeUserStatus(e,i) }>
													<img src={ DisableIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.USERS,'write') && i.deleted_at == null && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.USERS,'write') && i.deleted_at == null && (
											<Tooltip title="Cambiar contraseña">
												<a className="link-icon" href="#" onClick={ (e: any) => this.changePassword(e,i) }>
													<img src={ LockIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.USERS,'write') && i.deleted_at == null && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Users);